import React from 'react';
import { Link } from 'react-router-dom';

const Me = () => {
    return (
        <>
            <p className="site-title">Andrew Lanpouthakoun</p>
            <p>
                <Link to="/projects">Projects</Link> &middot;{' '}
                <Link to="/writing">Writing</Link>
            </p>
        </>
    );
};

export default Me;
